import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { pricingPlans, communityUrl } from '@/mocks/strategix';

export default function Pricing() {
  return (
    <section id="pricing" className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Тарифы"
          title="Индивидуальные тарифы под ваш проект"
          description="Тарифы у нас индивидуальные: цены обновляются в зависимости от рекламного аукциона и партнёрской программы рекламных платформ. Точную стоимость и наполнение уточняйте в сообществе."
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5 items-stretch">
          {pricingPlans.map((plan, index) => (
            <Reveal key={plan.name} delay={index * 110} className="h-full">
              <div
                className={`relative h-full flex flex-col p-6 md:p-7 rounded-lg border transition-colors ${
                  plan.popular
                    ? 'bg-primary-500/10 border-primary-400/60'
                    : 'bg-background-100/70 border-background-200/70 hover:border-primary-400/60'
                }`}
              >
                {plan.popular && (
                  <span className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    Оптимальный выбор
                  </span>
                )}

                <h3 className="font-heading text-lg md:text-xl text-foreground-950">{plan.name}</h3>
                <p className="mt-2 text-sm text-foreground-600">{plan.tagline}</p>

                <div className="mt-8 flex-1 flex items-center">
                  <span className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                    {plan.price}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-12 p-6 md:p-8 rounded-lg bg-primary-500/10 border border-primary-400/50 text-center">
            <h3 className="font-heading text-lg md:text-xl text-foreground-950">
              Наполнение тарифа уточняется в сообществе
            </h3>
            <p className="mt-3 max-w-2xl mx-auto text-sm text-foreground-700 leading-relaxed">
              Цены обновляются в зависимости от рекламного аукциона и партнёрской программы рекламных платформ.
              Поэтому точную стоимость и состав работ под ваш проект мы обсуждаем индивидуально — напишите нам,
              и подберём оптимальный объём.
            </p>
            <a
              href={communityUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-6 inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="fa-brands fa-vk text-base"></i>
              Перейти в сообщество ВК
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}